export default __webpack_public_path__ + "static/media/key-step5.6600e467.gif";